import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  imports: [TranslateModule, CommonModule],
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() title: string = '';
  @Input() searchType: boolean = false;
  @Input() tall: boolean = false;
  @Input() medium: boolean = false;
  @Input() small: boolean = false;
  @Input() black: boolean = false;
  @Input() disabled: boolean = false;
  @Input() redAlert: boolean = false;
  /** Defaults to the browser's implicit 'submit'; use 'button' for non-submitting buttons inside a form. */
  @Input() type: 'button' | 'submit' | 'reset' = 'submit';
  /**
   * Stable hook for end-to-end tests. Set it on the wrapper and it lands on the rendered
   * <button>, so specs never reach through this component's markup or match its label text.
   */
  @Input() testId: string = '';
}
